import { Link } from "react-router-dom";

interface BrandLogoProps {
  tone?: "dark" | "light";
  compact?: boolean;
}

export default function BrandLogo({ tone = "dark", compact = false }: BrandLogoProps) {
  const isLight = tone === "light";
  return (
    <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="糖豆视频首页">
      <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800">
        <i className="ri-play-fill text-lg text-accent-400" />
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading text-[17px] font-extrabold tracking-tight ${
            isLight ? "text-background-50" : "text-foreground-950"
          }`}
        >
          糖豆视频
        </span>
        {!compact && (
          <span
            className={`mt-1 text-[10px] font-semibold tracking-[0.2em] ${
              isLight ? "text-background-300" : "text-foreground-500"
            }`}
          >
            TANGDOU TV
          </span>
        )}
      </span>
    </Link>
  );
}